'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _ElementIcon = require('../../../components/elementIcon/ElementIcon');

var _ElementIcon2 = _interopRequireDefault(_ElementIcon);

var _BoardStatus = require('./BoardStatus');

var _BoardStatus2 = _interopRequireDefault(_BoardStatus);

var _BoardLock = require('./BoardLock');

var _BoardLock2 = _interopRequireDefault(_BoardLock);

var _BoardImage = require('./BoardImage');

var _BoardImage2 = _interopRequireDefault(_BoardImage);

var _ElementUserTag = require('../../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _colorHelper = require('../../../../common/colors/colorHelper');

var _gridSizeSelector = require('../../../utils/grid/gridSizeSelector');

var _gridUtils = require('../../../utils/grid/gridUtils');

var _dontUpdateForKeys = require('../../../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

require('./BoardIcon.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var getStyle = function getStyle(_ref) {
    var size = _ref.size,
        color = _ref.color,
        gridSize = _ref.gridSize,
        hasImageData = _ref.hasImageData;

    var iconSize = (0, _gridUtils.gridPointsToPixels)(size, gridSize);

    var style = {
        width: iconSize,
        height: iconSize
    };

    if (color && !hasImageData) {
        style.backgroundColor = (0, _colorHelper.getColorHexValue)(color);
    }

    return style;
};

// Styles


// Utils


var BoardIcon = function BoardIcon(props) {
    var icon = props.icon,
        element = props.element,
        size = props.size,
        gridSize = props.gridSize,
        color = props.color,
        registerConnectionOrigin = props.registerConnectionOrigin,
        showNavigationFeedback = props.showNavigationFeedback;


    var hasImageData = element && (element.getIn(['content', 'image']) || element.getIn(['attachment', 'data']));
    var iconElement = hasImageData ? _react2.default.createElement(_BoardImage2.default, { element: element, size: size, gridSize: gridSize }) : _react2.default.createElement(_ElementIcon2.default, { icon: icon, showLoading: true, enableFade: true });

    var boardIconContentStyle = getStyle({ size: size, color: color, gridSize: gridSize, hasImageData: hasImageData });
    var boardIconClass = boardIconContentStyle.width < 60 ? 'small' : null;
    var preNavClass = { 'pre-nav': showNavigationFeedback };

    var wrapperFn = registerConnectionOrigin || _lodash.identity;

    return wrapperFn(_react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('BoardIcon', boardIconClass, preNavClass) },
        _react2.default.createElement(_ElementUserTag2.default, props),
        _react2.default.createElement(
            'div',
            { className: 'board-icon-content drag-handle', style: boardIconContentStyle },
            iconElement,
            _react2.default.createElement(_BoardStatus2.default, props),
            _react2.default.createElement(_BoardLock2.default, props)
        )
    ));
};

BoardIcon.propTypes = {
    size: _propTypes2.default.number.isRequired,
    iconName: _propTypes2.default.string,
    color: _propTypes2.default.string,
    icon: _propTypes2.default.object,
    gridSize: _propTypes2.default.number,
    element: _propTypes2.default.object,
    registerConnectionOrigin: _propTypes2.default.func,
    showNavigationFeedback: _propTypes2.default.bool
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(_gridSizeSelector.gridSizeSelector), (0, _dontUpdateForKeys2.default)(['elementEvents', 'isSelected', 'readyToMeasure', 'childrenTypes', 'isBoardFetched']));

exports.default = enhance(BoardIcon);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardIcon/BoardIcon.js
// module id = 451
// module chunks = 0